/**
 * @desc 检查平台订单号是否可用并且关联订单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/checkUsableBySoOrderNo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
